import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { FaQuoteLeft, FaCameraRetro } from "react-icons/fa";
import { FaStar } from "react-icons/fa6";
import { clients } from "../Testimonial";

import "swiper/css";
import "swiper/css/pagination";

const whyItems = [
  "Save 6-10 hours per wedding",
  "Consistent editing in your style",
  "Fastest turnaround time (24-48 hrs)",
  "Professional editors & manual editing",
  "Secure file transfer & 100% privacy",
  "Unlimited revisions until you're happy",
  "Bulk discounts & flexible pricing",
  "Dedicated support",
];

const pricing = [
  { label: "Color Correction", price: "$0.08", unit: "/image" },
  { label: "Retouching", price: "$1.50", unit: "/image" },
  { label: "Real Estate Editing", price: "$1.00", unit: "/image" },
  { label: "Album Design", price: "$0.80", unit: "/page" },
  { label: "Video Editing", price: "$25", unit: "/project" },
];

const WhyPricingTestimonial = () => {
  return (
    <section className="trust-pricing-section">
      <div className="trust-pricing-grid">
        <div className="trust-pricing-card">
          <h3 className="trust-pricing-card-title">
            Why Outsource to Capture Edits?
          </h3>
          <ul className="why-list">
            {whyItems.map((item) => (
              <li key={item}>
                <span className="why-check">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="trust-pricing-card">
          <h3 className="trust-pricing-card-title">
            Simple & Transparent Pricing
          </h3>
          <div className="pricing-rows">
            {pricing.map((row) => (
              <div className="pricing-row" key={row.label}>
                <span className="pricing-label">{row.label}</span>
                <span className="pricing-value">
                  {row.price} <small>{row.unit}</small>
                </span>
              </div>
            ))}
          </div>
          <a href="#services-grid" className="pricing-cta">
            View Full Pricing
          </a>
        </div>

        <div className="trust-pricing-card testimonial-card">
          <h3 className="trust-pricing-card-title">What Our Clients Say</h3>
          <Swiper
            className="mini-testimonial-swiper"
            slidesPerView={1}
            pagination={{ clickable: true }}
            modules={[Pagination]}
          >
            {clients.map((client) => (
              <SwiperSlide key={client.name}>
                <FaQuoteLeft className="testimonial-quote-icon" />
                <p className="testimonial-quote-text">{client.rewiew}</p>
                <div className="testimonial-author">
                  <div className="testimonial-avatar">
                    <FaCameraRetro />
                  </div>
                  <div>
                    <div className="testimonial-author-name">
                      {client.name}
                    </div>
                    <div className="testimonial-stars">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                  </div>
                  <div className="text-center ms-auto">
                    <div className="fs-14 text-muted">Country</div>
                    <strong>{client.country}</strong>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default WhyPricingTestimonial;
